import React from 'react';
import { connect } from 'react-redux';

import { ControlLabel } from 'react-bootstrap';
import {
  selectFlattenedOrgGroups,
  selectRetrieveGroupsState,
} from '../../modules/orgGroups.js';

import IncludeEmployeesCheckbox from '../employees-form-field/IncludeEmployeesCheckbox.jsx';
import GroupRow from './GroupRow.jsx';

const mapStateToProps = (state) => ({
  flattenedGroups: selectFlattenedOrgGroups(state),
  retrieveSuccess: selectRetrieveGroupsState(state).success,
});

function SelectedGroups(props) {
  const {
    flattenedGroups,
    selected,
    handleSelect,
    onSelectAllGroupEmployees,
    retrieveSuccess,
    onShowManageModal,
  } = props;

  return (
    retrieveSuccess &&
    Object.values(selected).map((group, index) => {
      const groupEntity = flattenedGroups.find((g) => g.id === group.id);

      return (
        <div key={group.id} className="m-b-20">
          <GroupRow
            index={index}
            group={groupEntity}
            handleRemove={handleSelect}
          />

          <div className="flex m-l-18">
            {onSelectAllGroupEmployees ? (
              <IncludeEmployeesCheckbox
                group={groupEntity}
                isChecked={
                  group.employee_ids.length &&
                  group.employee_ids.length === groupEntity.employeeIds.length
                }
                handleSelect={onSelectAllGroupEmployees}
              />
            ) : (
              <ControlLabel className="m-b-10 m-t-10">
                Selected Employees
              </ControlLabel>
            )}

            <strong className="bordered bordered-xs text-muted m-l-8">
              Total:&nbsp;
              <span className="text-info-brand count">
                {group.employee_ids.length}
              </span>
            </strong>

            <button
              type="button"
              className="btn-clear btn-link m-l-4 m-r-40"
              onClick={() => onShowManageModal(group.id)}
            >
              Manage
            </button>
          </div>
        </div>
      );
    })
  );
}

export default connect(mapStateToProps)(SelectedGroups);
